export default __webpack_public_path__ + "static/media/rs.1563c2c1.jfif";